// @react/hooks/useProjectView.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { projectViewStore } from '@core/stores';

/**
 * React hook for SavedView operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useProjectView } from '@react/hooks';
 *
 * const SavedViewList = observer(() => {
 *   const store = useProjectView();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useProjectView() {
  return projectViewStore;
}
